module.exports = __webpack_public_path__ + "img/PGenGraphic.be87b0ef.svg";